// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"F4-z"};